import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Post } from 'src/app/models/post';
import { MiradoresService } from 'src/app/services/miradores.service';

@Component({
  selector: 'app-current-month-top-viewpoints',
  templateUrl: './current-month-top-viewpoints.component.html',
  styleUrls: ['./current-month-top-viewpoints.component.scss'],
})
export class CurrentMonthTopViewpointsComponent implements OnInit {
  @Input() post: Post;

  constructor(public MIService: MiradoresService, private router: Router) {}

  ngOnInit() {
  }

  seeDetail(viewpoint) {
    this.router.navigate([
      '/mirador',
      this.MIService.getNormalizedMiradorNameForURL(viewpoint.dataMirador.name),
    ]);
  }
}
